import {reducerRegistry} from 'store/entities';
import {combineReducers} from './combineReducers';

export const rootReducer = combineReducers(reducerRegistry);
